<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogLedger"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dense
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="LedgerDialogClose()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Terminal Ledger Report</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card class="pa-3">
          <v-row>
            <v-col>
                <v-toolbar flat color="grey" dark dense>
                  <v-toolbar-title>Enrolled Terminals</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              <v-text-field
                v-model="searchTerminal"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                ></v-text-field>
              <v-data-table
                dense
                :headers="terminalCreds"
                :items="enrolledTerminals"
                :search="searchTerminal"
                item-key="terminalLocation"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item="{ item }">
                  <tr @click="openTerminalMethod(item)" style="cursor:pointer">
                    <td v-if="item.enabled" class="statusCell">In use</td>
                    <td v-else class="statusCell">Disabled</td>
                    <td>{{ item.terminalLocation }}</td>
                    <td class="hashCell">{{ item.terminalId }}</td>
                    <td>{{ item.loggedOut }}</td>
                    <td>{{ item.venueCode }}</td>
                    <td>{{ item.username }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col md="auto" class="pa-0" style="max-width:35px">
              <v-icon large class="mt-5">mdi-chevron-double-right</v-icon>
            </v-col>
            <v-col>
              <v-toolbar flat color="grey" dark dense>
                  <v-toolbar-title>{{terminalShown}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              <v-row class="mt-4 ml-1">
                <v-col>
                <ledger-date-picker :value="dateRange" @range-changed="setDateRange"/>
                </v-col>
                <v-col>
                  <v-btn>
                  <download-csv
                  style="cursor:pointer"
                  :data="downLoadBets"
                  :name="fileDate">
                    Download Data
                    <v-icon small>mdi-download</v-icon>
                  </download-csv>
                  </v-btn>
                </v-col>
              </v-row>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                ></v-text-field>
              <v-data-table
                dense
                :headers="headers"
                :items="bets"
                :search="search"
                item-key="ticketId"
                hide-default-footer
                disable-pagination
              >
              <template v-slot:item="{ item }">
                <tr @click="openTicket(item)" style="cursor:pointer">
                  <td>{{ TICKET_TYPES[item.status] }}</td>
                  <td>{{ ticketIdHidden(item.ticketId) }}</td>
                  <td>{{ item.betId }}</td>
                  <td>{{ item.externalBetId }}</td>
                  <td>{{ item.username }}</td>
                </tr>
              </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
      <v-dialog
        v-model="ticketModal"
        max-width="290"
      >
        <v-card >
          <v-card-title class="text-h5">
            Ticket Details
          </v-card-title>
          <v-card-text>
            <strong>Ticket ID: </strong>{{ ticketIdHidden(ticket.id) }}
            <br>
            <strong>Bet ID: </strong>{{ ticket.betId }}
            <span><br><strong>Status: </strong></span>{{ ticket.status }}
            <br><strong>Bet Type: </strong>{{ ticket.betType }}
            <br><strong>Track/Event: </strong>{{ ticket.raceName }}
            <br><strong>Race: </strong>{{ ticket.raceNumber }}
            <br><strong>Runner: </strong>{{ ticket.runnerName }}
            <br><strong>Stake: </strong>${{ ticket.stake }}
            <br><strong>Odds: </strong>{{ ticket.odds }}
            <br><strong>Time placed: </strong>{{ ticket.placedAt }}
            <br>
            <br>
            <br><strong>Paid: </strong>${{ ticket.paid }}
            <br><strong>Payout Owing: </strong>${{ ticket.payoutOwing }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              text
              @click="ticketModal = false"
            >
              Close
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="printDiv('hiddenTicket')"
            >
              Print
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
      <v-card id="hiddenTicket">
        <v-card-text>
          <strong>Ticket ID: </strong>{{ ticketIdHidden(ticket.id) }}
          <br>
          <strong>Bet ID: </strong>{{ ticket.betId }}
          <span><br><strong>Status: </strong></span>{{ ticket.status }}
          <br><strong>Bet Type: </strong>{{ ticket.betType }}
          <br><strong>Track/Event: </strong>{{ ticket.raceName }}
          <br><strong>Race: </strong>{{ ticket.raceNumber }}
          <br><strong>Runner: </strong>{{ ticket.runnerName }}
          <br><strong>Stake: </strong>${{ ticket.stake }}
          <br><strong>Odds: </strong>{{ ticket.odds }}
          <br><strong>Time placed: </strong>{{ ticket.placedAt }}
          <br>
          <br>
          <br><strong>Paid: </strong>${{ ticket.paid }}
          <br><strong>Payout Owing: </strong>${{ ticket.payoutOwing }}
        </v-card-text>
      </v-card>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { LedgerDatePicker } from '..'
import { TICKET_TYPES } from '../../common/constants'

export default {
  name: 'TerminalLedger',
  data () {
    return {
      ticketModal: false,
      TICKET_TYPES,
      terminal: [],
      search: '',
      searchTerminal: '',
      headers: [
        {
          text: 'Status',
          align: 'start',
          filterable: false,
          value: 'status'
        },
        { text: 'Ticket Id', value: 'ticketId' },
        { text: 'Bet Id', value: 'betId' },
        { text: 'External Bet Id', value: 'externailBetId' },
        { text: 'Operator', value: 'username' }
      ],
      terminalCreds: [
        {
          text: 'Status',
          align: 'start',
          filterable: false,
          value: 'status'
        },
        { text: 'Terminal Loc Id', value: 'terminalLocation' },
        { text: 'Hash', value: 'terminalId' },
        { text: 'Last used', value: 'dateLast' },
        { text: 'Venue', value: 'Venue' },
        { text: 'Last User', value: 'username' }
      ]
    }
  },
  components: {
    LedgerDatePicker
  },
  props: {
    LedgerDialog: {
      type: Boolean,
      default: false
    },
    LedgerDialogClose: {
      type: Function
    }
  },
  computed: {
    ...mapState(['dateFromTerminalLedger', 'dateToTerminalLedger']),
    ...mapGetters(['getEnrolledTerminals', 'getBetTickets', 'getTicketSelected', 'getTerminalSelected']),
    dateRange () {
      return {
        start: this.dateFromTerminalLedger,
        end: this.dateToTerminalLedger
      }
    },
    fileDate () {
      return `${this.terminal.terminalLocation} date ${this.dateRange.start} to ${this.dateRange.end}.csv`
    },
    terminalShown () {
      if (this.terminal.terminalLocation) return `Ledger History for: ${this.terminal.terminalLocation} | date ${this.dateRange.start} to ${this.dateRange.end}`
      return 'Please select a terminal'
    },
    dialogLedger () {
      return this.LedgerDialog
    },
    enrolledTerminals () {
      return this.getEnrolledTerminals
    },
    bets () {
      return this.getBetTickets
    },
    downLoadBets () {
      const data = this.bets
      return data.map((bet) => ({ ...bet, ticketId: this.ticketIdHidden(bet.ticketId), status: TICKET_TYPES[bet.status] }))
    },
    ticket () {
      return this.getTicketSelected
    }
  },
  methods: {
    ...mapActions(['setDatesTerminalLedger', 'fetchListTickets', 'fetchTicket', 'selectTerminal']),
    async openTicket (v) {
      await this.fetchTicket({ terminalId: this.terminal.terminalId, ticketId: v.ticketId })
      this.ticketModal = true
    },
    ticketIdHidden (id) {
      if (id) return id.replace(/^.{4}/g, '****')
      return '-'
    },
    setDateRange (r) {
      this.setDatesTerminalLedger(r)
      const terminal = this.getTerminalSelected
      this.openTerminalMethod(terminal)
    },
    // printDiv (ticketDiv) {
    //   this.ticketModal = false
    //   const specific = document.getElementById(ticketDiv).innerHTML
    //   const original = document.body.innerHTML
    //   document.body.innerHTML = specific
    //   window.print()
    //   document.body.innerHTML = original
    // },
    printDiv (id) {
      var data = document.getElementById(id).innerHTML
      var myWindow = window.open('', 'my div', 'height=400,width=600')
      myWindow.document.write('<html><head><title>my div</title>')
      myWindow.document.write('</head><body >')
      myWindow.document.write(data)
      myWindow.document.write('</body></html>')
      myWindow.document.close() // necessary for IE >= 10
      myWindow.print()
    },
    openTerminalMethod (terminal) {
      this.terminal = terminal
      this.selectTerminal({ terminal: terminal })
      this.fetchListTickets({ terminalId: terminal.terminalId, dateFrom: this.dateFromTerminalLedger, dateTo: this.dateToTerminalLedger })
    }
  }
}
</script>

<style scoped>
.statusCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hashCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:100px;
}
#hiddenTicket {
  display:none
}
</style>
